import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function unitDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/unit/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
